// src/utils/detectUserAgent.js
// UA-CH(userAgentData) 없이, 순수 userAgent 기반 감지 유틸
// SSR 안전(브라우저 아님 환경에서는 전부 false)

function getUA() {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

function parseUserAgent(ua) {
  // 브라우저/엔진
  const edge = /\bEdg(?:e|A|iOS)?\//.test(ua); // Edge (Chromium/Android/iOS)
  const opera = /\bOPR\//.test(ua); // Opera
  const samsung = /\bSamsungBrowser\//.test(ua); // Samsung Browser
  const firefox = /\bFirefox\/|\bFxiOS\//.test(ua); // Firefox / Firefox iOS
  const hasChrome = /\bChrome\/|\bCriOS\//.test(ua); // Chrome / Chrome iOS
  const android = /Android/.test(ua);

  // Chrome: Edge/Opera/Samsung 제외
  const chrome = hasChrome && !edge && !opera && !samsung;

  // Safari: Safari 표기 & Chrome/Edge/Opera/Android 아님
  const safari =
    /Safari\//.test(ua) && !hasChrome && !edge && !opera && !android;

  // iPad: iPad 또는 iPadOS(맥으로 위장 + Mobile 토큰)
  const ipad =
    /\biPad\b/.test(ua) ||
    (/\bMacintosh\b/.test(ua) && /\bMobile\/\w+/.test(ua));
  const iphone = /\biPhone\b/.test(ua);
  const ipod = /\biPod\b/.test(ua);
  const ios = ipad || iphone || ipod;

  // 모바일 판단: iOS, Android, 또는 UA의 Mobile 토큰
  const mobile = ios || android || /\bMobile\/\w+/.test(ua);

  // Windows (platform 대신 UA 키워드로)
  const windows = /\bWindows NT\b|; Win/.test(ua);

  return {
    // OS/디바이스
    windows,
    android,
    ios,
    ipad,
    iphone,
    ipod,
    mobile,
    // 브라우저
    chrome,
    firefox,
    safari,
    edge,
    opera,
    samsung,
    // 원문 UA
    userAgent: ua,
  };
}

// 호출 시마다 fresh 계산(가벼운 정규식들이라 비용 미미)
// 필요하면 아주 쉽게 메모이제이션 가능
export function detectUserAgent() {
  return parseUserAgent(getUA());
}

// is_js 대체용 인터페이스 (기존 코드 변경 최소화용)
// 사용 예: import is from '@/utils/detectUserAgent'; is.mobile(), is.ipad(), is.safari(), is.chrome()
const api = {
  // 디바이스/OS
  mobile: () => detectUserAgent().mobile,
  ios: () => detectUserAgent().ios,
  ipad: () => detectUserAgent().ipad,
  iphone: () => detectUserAgent().iphone,
  android: () => detectUserAgent().android,
  windows: () => detectUserAgent().windows,
  // 브라우저
  chrome: () => detectUserAgent().chrome,
  firefox: () => detectUserAgent().firefox,
  safari: () => detectUserAgent().safari,
  edge: () => detectUserAgent().edge,
  opera: () => detectUserAgent().opera,
  samsung: () => detectUserAgent().samsung,
  // 전체 정보가 필요할 때
  info: () => detectUserAgent(),
};

export default api;
